export const CorporateMenu = {
  MAIN: {
    title: 'Home',
    iconPath: '../../../assets/new-icons/home-icon.svg',
    subMenus: {
      DASHBOARD: {
        title: 'Panel de Control',
        iconPath: '../../assets/vector-icon.svg',
        link: '/dashboard',
      },
      COMPANIES: {
        title: 'Empresas',
        iconPath: '../../assets/vector-icon.svg',
        link: '/companies',
      }
    }
  },
  CUSTOMERS: {
    title: 'Clientes',
    iconPath: '../../../assets/new-icons/user-version-2.svg',
    link: '/customers/corporatelist'
  },
  INVOICES: {
    title: 'Ordenes de pago',
    iconPath: '../../../assets/new-icons/file-text-version-2.svg',
    link: '/corporate/invoices'
  },
  REPORTS: {
    title: 'Reportes',
    iconPath: '../../../assets/new-icons/file-lines-version-2.svg',
    subMenus: {
      SETTLEMENT: {
        title: 'Liquidaciones',
        iconPath: '../../assets/vector-icon.svg',
        link: '/corporate/settlements'
      },
      PAYMENTS: {
        title: 'Pagos',
        iconPath: '../../assets/vector-icon.svg',
        link: '/corporate/payments'
      },
      NOTIFICATIONS: {
        title: 'Notificaciones',
        iconPath: '../../assets/vector-icon.svg',
        link: '/corporate/reports/notificationlist'
      }
    }
  },
  CONFIGURATION: {
    title: 'Configuración',
    iconPath: '../../../assets/new-icons/settings-icon.svg',
    link: '/new_configuration_layout'
  }
};

export const CompanyMenu = {
  MAIN: {
    title: 'Home',
    iconPath: '../../../assets/new-icons/home-icon.svg',
    subMenus: {
      DASHBOARD: {
        title: 'Panel de Control',
        iconPath: '../../assets/vector-icon.svg',
        link: '/dashboard',
      },
      COMPANIES: {
        title: 'Empresas',
        iconPath: '../../assets/vector-icon.svg',
        link: '/companiescallback',
      }
    }
  },
  CUSTOMERS: {
    title: 'Clientes',
    iconPath: '../../../assets/new-icons/user-version-2.svg',
    link: '/customers'
  },
  INVOICES: {
    title: 'Ordenes de pago',
    iconPath: '../../../assets/new-icons/file-text-version-2.svg',
    linkPayment: '/payments/invoices',
    linkCollect: '/collect/invoices',
    linkPayout: '/payout/invoices'
  },
  SALES: {
    title: 'Sales',
    iconPath: '../../assets/principal-icon.svg',
    subMenus: {
      LIST: {
        title: 'Lista',
        iconPath: '../../assets/vector-icon.svg',
        link: '/sales'
      },
      CREATE: {
        title: 'Crear',
        iconPath: '../../assets/vector-icon.svg',
        link: '/sales/create'
      }
    }
  },
  PAYMENTS: {
    title: 'Pagos',
    iconPath: '../../assets/principal-icon.svg',
    subMenus: {
      LIST: {
        title: 'Lista',
        iconPath: '../../assets/vector-icon.svg',
        link: '/payments'
      },
      CREATE: {
        title: 'Crear',
        iconPath: '../../assets/vector-icon.svg',
        link: '/payments/create'
      }
    }
  },
  PAYOUTS: {
    title: 'Pagos Masivos',
    iconPath: '../../assets/principal-icon.svg',
    subMenus: {
      LIST: {
        title: 'Lista',
        iconPath: '../../assets/vector-icon.svg',
        link: '/payout_process/list'
      },
      CREATE: {
        title: 'Crear',
        iconPath: '../../assets/vector-icon.svg',
        link: '/payout_process_commerce/list'
      }
    }
  },
  ACCOUNTS: {
    title: 'Cuentas',
    iconPath: '../../assets/new-icons/layers-three-icon.svg',
    subMenus: {
      LIST: {
        title: 'Lista',
        iconPath: '../../assets/vector-icon.svg',
        link: '/accounts'
      }
    }
  },
  REPORTS: {
    title: 'Reportes',
    iconPath: '../../../assets/new-icons/file-lines-version-2.svg',
    subMenus: {
      SETTLEMENT: {
        title: 'Liquidaciones',
        iconPath: '../../assets/vector-icon.svg',
        link: '/settlements'
      },
      PAYMENTS: {
        title: 'Pagos',
        iconPath: '../../assets/vector-icon.svg',
        link: '/reports/payments'
      },
      NOTIFICATIONS: {
        title: 'Notificaciones',
        iconPath: '../../assets/vector-icon.svg',
        link: '/reports/notificationlist'
      }
    }
  },
  CONFIGURATION: {
    title: 'Configuración',
    iconPath: '../../../assets/new-icons/settings-icon.svg',
    link: '/new_configuration_layout'
  }
};
